import {useCallback, useEffect} from 'react';

import {useCountryList} from '@/context/CountryListContext';
import {CountryListActionType} from '@/context/types';
import {kycService} from '@/services/kycService';
import {getErrorMessage} from '@/utils/errorMessage';
import {showErrorMessage} from '@/utils/showErrorMessage';

export const useCountryListFetcher = () => {
  const {dispatch, state} = useCountryList();

  const fetchCountryList = useCallback(async () => {
    try {
      dispatch({
        type: CountryListActionType.FETCH_COUNTRIES,
        payload: {loading: true},
      });

      const {data: countries} = await kycService.getCountryList({});
      dispatch({
        type: CountryListActionType.FETCH_COUNTRIES,
        payload: {countryList: countries || [], loading: false},
      });
    } catch (e) {
      dispatch({
        type: CountryListActionType.FETCH_COUNTRIES,
        payload: {countryList: [], loading: false},
      });
      showErrorMessage(
        `Fetching country list failed: ${getErrorMessage(e, String(e))}`,
      );
    }
  }, [dispatch]);

  useEffect(() => {
    // Fire-and-forget: fetchCountryList catches and surfaces its own failures,
    // so this only stops an unexpected throw becoming an unhandled rejection.
    fetchCountryList().catch(() => {});
  }, [fetchCountryList]);

  return {
    countryList: state.countryList,
    fetchCountryList,
    isLoading: state.loading,
  };
};
